export default {
  drawer: null,
  color: 'primary',
  image: '/img/sidebar.jpg'
}
